export type BooleanDisplay = 'Yes' | 'No' | 'N/A';
export const Positive: Extract<BooleanDisplay, 'Yes'> = 'Yes';
export const Negative: Extract<BooleanDisplay, 'No'> = 'No';
export const Unavailable: Extract<BooleanDisplay, 'N/A'> = 'N/A';

export const format = (value?: boolean | string, binary = true): BooleanDisplay => {
	return binary || value !== null ? (!value || value === '' ? Negative : Positive) : Unavailable;
};

export const isNull = (val: boolean | string) => val === null || val === Unavailable;
export const isFalse = (val: boolean | string) =>
	val === false ||
	val === '' ||
	val.toString().toLowerCase() === Negative.toLowerCase() ||
	val.toString().toLowerCase() === 'false';
export const isTrue = (val: boolean | string) => !isFalse(val);
export const isFalsey = (val: boolean | string) => isFalse(val) || isNull(val);
export const isTruthy = (val: boolean | string) => isTrue(val) && !isNull(val);
